const getChargingTokenDesigns = (state) => {
  return state.main.chargingTokenDesignState.chargingTokenDesigns
}
const getFetchChargingTokenDesignsRequestState = (state) => {
  return state.main.chargingTokenDesignState
    .fetchChargingTokenDesignsRequestState
}
const getFetchAllChargingTokenDesignsRequestState = (state) => {
  return state.main.chargingTokenDesignState
    .fetchAllChargingTokenDesignsRequestState
}
const getPaginationOffset = (state) => {
  return state.main.chargingTokenDesignState.paginationOffset
}
const getAllChargingTokenDesigns = (state) => {
  return state.main.chargingTokenDesignState.allChargingTokenDesigns
}

const getAddChargingTokenDesignRequestState = (state) => {
  return state.main.chargingTokenDesignState.addChargingTokenDesignRequestState
}
const getEditChargingTokenDesignRequestState = (state) => {
  return state.main.chargingTokenDesignState.editChargingTokenDesignRequestState
}
const getAppChargingDesignsTokenCount = (state) => {
  return state.main.chargingTokenDesignState.count
}
const getGetChargingTokenCountRequestState = (state) => {
  return state.main.chargingTokenDesignState.getChargingTokenCountRequestState
}
const getDeleteChargingTokenDesignRequestState = (state) => {
  return state.main.chargingTokenDesignState
    .deleteChargingTokenDesignRequestState
}
const ChargingTokenDesignSelectors = {
  getChargingTokenDesigns,
  getFetchChargingTokenDesignsRequestState,
  getPaginationOffset,
  getAllChargingTokenDesigns,
  getAddChargingTokenDesignRequestState,
  getEditChargingTokenDesignRequestState,
  getFetchAllChargingTokenDesignsRequestState,
  getAppChargingDesignsTokenCount,
  getGetChargingTokenCountRequestState,
  getDeleteChargingTokenDesignRequestState,
}

export default ChargingTokenDesignSelectors
